import type {
  CreditProcessorDownloadPdfInvoiceRequestType,
  CreditProcessorDownloadPdfInvoiceResponseType,
} from "@sellar-io/api-v2/types";
import { useMutation } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";

export const useCreditProcessorDownloadOrderInvoice = () => {
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: (data: CreditProcessorDownloadPdfInvoiceRequestType) =>
      apiV2Request({
        user,
        business,
        method: "POST",
        path: `credit-processor/download-invoice/${data.orderId}/pdf`,
      }).then(
        (data) =>
          apiV2AssertResponse(data)
            .data as CreditProcessorDownloadPdfInvoiceResponseType,
      ),
  });
};
